import React from 'react'
import { Row, Col } from 'react-bootstrap'
import moment from 'moment'
import DatePicker from '../../../LaridaeApp/datepicker/container/DatePicker'
import { CerealDropdown, EntityAutocomplete } from '../../../Forms/SharedComponents/containers'
import { Field } from 'redux-form'
import { renderTextField } from '../../../Forms/fieldRenderers'

export default function CamposCargaBuque (props) {
  const { actualizarFechas, detalleInicial = null, actualizacion = false } = props
  return (
    <>
      <Row>
        <Col md={3}>
          <DatePicker
            disabledPast
            selectRange={!actualizacion}
            locale='es'
            onDateChange={actualizarFechas}
            titulo='Fechas de carga *'
            fechaDesde={detalleInicial ? moment(detalleInicial.fechaDeCarga).format('DD-MM-YYYY') : null}
            fechaHasta={detalleInicial ? moment(detalleInicial.fechaDeCarga).format('DD-MM-YYYY') : null}
          />
        </Col>
        <Col md={3}>
          <EntityAutocomplete
            name='exportador'
            label='Exportador *'
            entity='exportador'
            placeholder='Exportador - 19999999991'
            value={''}
          />
        </Col>

        <Col md={3}>
          <CerealDropdown required cerealInicial={detalleInicial ? detalleInicial.claveCereal : null} />
        </Col>
        <Col md={3}>
          <Field
            name='toneladas'
            label='Total en toneladas a cargar'
            component={renderTextField}
            maxLength={5}
          />
        </Col>
        <Col md={12} style={{ marginTop: '8px' }}>
          <p>(*) Campo requerido obligatorio</p>
        </Col>
      </Row>
    </>
  )
}
